module.exports = __webpack_public_path__ + "media/images/lb/351-7069502705419a8a22f6177888baccd0.svg";